import React, { useEffect } from "react";
import { OBJECT_TYPES } from "../../../../../services/api/dynamic-fields-api";
import { renderTaskDetailDynamicFields } from "../helpers/task-helpers";
import { getDynamicFields } from "../../../../../components/DynamicField/Tasks/utils/fieldsUtils";
import PropTypes from 'prop-types';

const DynamicTaskDetails = ({ standardTask, values, touched, dynamicFields, setDynamicFields, disabled }) => {


    const dynamicFieldRequestDto = {
        projectTypeId: standardTask.ProjectTypeId,
        taskTypeId: values.workItemType,
        objectType: OBJECT_TYPES.taskDetail,
        objectId: standardTask.Id
    };

    useEffect(() => {
        getDynamicFields(dynamicFieldRequestDto)
            .then(setDynamicFields)
            .catch((error) => {
                setDynamicFields([]);
                console.error(error);
            });
    }, [standardTask.ProjectTypeId, values.workItemType, OBJECT_TYPES.taskDetail, standardTask.assignID]);

    return (
        <div>

            {dynamicFields.filter((item) => item.FieldType !== 'Table')?.length > 0 &&
                <div className="dynamic-section-container">
                    {renderTaskDetailDynamicFields({
                        dynamicFields: dynamicFields.filter((item) => item.FieldType !== 'Table'),
                        setDynamicFields,
                        disableErrors: Object.keys(touched).length === 0,
                        disabled,
                        taskWithWorkflow: standardTask
                    })}
                </div>}
            {/* TABLE */}
            {dynamicFields.filter((item) => item.FieldType === 'Table').length > 0 &&
                <div className='mt-3'>
                    {renderTaskDetailDynamicFields({
                        dynamicFields: dynamicFields.filter((item) => item.FieldType === 'Table'),
                        setDynamicFields,
                        disableErrors: Object.keys(touched).length === 0,
                        disabled,
                        taskWithWorkflow: standardTask
                    })}
                </div>
            }
        </div>
    );
}

DynamicTaskDetails.propTypes = {
    standardTask:PropTypes.object, 
    values:PropTypes.object,
    touched:PropTypes.object,
    dynamicFields:PropTypes.array,
    setDynamicFields:PropTypes.func,
    disabled:PropTypes.bool,
};
export default DynamicTaskDetails;